import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-enrollment-select-info',
  components: {},
})
export default class EnrollmentSelectInfo extends Vue {
  @Prop(Object) readonly element: Record<string, any>;

  public onClick($event) {
    this.$emit('click', this.element);
  }
}
